module.exports = __webpack_public_path__ + "static/Midnight_feature-d2b7075360513d772f0dbd2ff61a6cc3.webp";